import { lazy } from 'react'
import { isSuccessVisit } from 'constants/visit-types'
import format from 'date-fns/format'

const ModalsMap = {
  // TODO - remove once pwUiComponents3PrescriptionForm FF is deprecated
  addPrescriptionOld: {
    Component: lazy(() => import('./AddPrescription')),
    label: 'Add Prescription',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  // TODO - remove once pwUiComponents3PrescriptionForm FF is deprecated
  editRxChangePrescriptionOld: {
    Component: lazy(() => import('./EditRxChangePrescriptionOld')),
    label: 'Edit Prescription',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  memberFamilyHistory: {
    Component: lazy(() => import('./MemberFamilyHistory')),
    label: 'Member Family History',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  memberMedicalHistory: {
    Component: lazy(() => import('./MemberMedicalHistory')),
    label: 'Member Medical History',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  memberAllergy: {
    Component: lazy(() => import('./MemberAllergy')),
    label: 'Member Allergy',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  deleteMemberRecord: {
    Component: lazy(() => import('./DeleteMemberRecord')),
    label: 'Delete Member Record',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  addAddendum: {
    Component: lazy(() => import('./AddAddendum')),
    label: 'Add Addendum Note',
    titleCancelButtonVariant: false,
    rootClassName: 'addAddendum',
  },
  psychotherapyNotes: {
    Component: lazy(() => import('./PsychotherapyNotes')),
    label: '',
    titleCancelButtonVariant: false,
    rootClassName: 'psychotherapyNotes',
  },
  briefScheduling: {
    Component: lazy(() => import('./BriefScheduling')),
    label: ({ visit }) => `Scheduled ${isSuccessVisit(visit?.visitType) ? 'Session' : 'Visit'}`,
    titleCancelButtonVariant: 'X',
    rootClassName: '',
  },
  hidstgs: {
    Component: lazy(() => import('./HiddenSettings')),
    label: 'Hidden settings',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  patientSummary: {
    Component: lazy(() => import('./PatientSummary')),
    label: ({ visit }) => `${isSuccessVisit(visit?.visitType) ? 'Student Success' : 'Patient Chart'} Summary`,
    titleCancelButtonVariant: true,
    rootClassName: 'patientSummary',
  },
  cancelVisit: {
    Component: lazy(() => import('./CancelVisit')),
    label: ({ visit }) => `Cancel ${isSuccessVisit(visit?.visitType) ? 'session' : 'visit'}`,
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  suggestTimes: {
    Component: lazy(() => import('./SuggestTimes')),
    label: 'Suggest New Times',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  phoneFallback: {
    Component: lazy(() => import('./PhoneFallback')),
    label: 'Call Failed',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  phoneSuccess: {
    Component: lazy(() => import('./PhoneSuccess')),
    label: 'Call Initiated',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  chatHistory: {
    Component: lazy(() => import('./ChatHistory')),
    label: '',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  photosImage: {
    Component: lazy(() => import('./PhotosImage')),
    label: '',
    titleCancelButtonVariant: true,
    rootClassName: '',
  },
  changePharmacy: {
    Component: lazy(() => import('./ChangePharmacy')),
    label: 'Change Pharmacy',
    titleCancelButtonVariant: true,
    rootClassName: '',
  },
  // TODO - remove once pwUiComponents3PrescriptionForm FF is deprecated
  denyRxChangeRequestOld: {
    Component: lazy(() => import('./DenyRxChangeRequestOld')),
    label: 'Deny request',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  // TODO - remove once pwUiComponents3PrescriptionForm FF is deprecated
  confirmRxChangeRequestOld: {
    Component: lazy(() => import('./ConfirmRxChangeRequestOld')),
    label: '',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  phoneVerification: {
    Component: lazy(() => import('./PhoneVerification')),
    label: 'Phone Verification',
    titleCancelButtonVariant: true,
    rootClassName: '',
  },
  dayVisits: {
    Component: lazy(() => import('./DayVisits')),
    label: ({ dateString }) => format(new Date(dateString), 'EEEE, MMMM do'),
    titleCancelButtonVariant: 'X',
    rootClassName: '',
  },
  setAvailability: {
    Component: lazy(() => import('./SetAvailability')),
    label: 'Set Availability',
    titleCancelButtonVariant: false,
    rootClassName: 'setAvailability',
  },
  blackoutDates: {
    Component: lazy(() => import('./BlackoutDates')),
    label: 'Blackout Dates',
    titleCancelButtonVariant: false,
    rootClassName: 'blackoutDates',
  },
  intakeResults: {
    Component: lazy(() => import('./IntakeResults')),
    label: 'Intake Results',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
  safetyPlan: {
    Component: lazy(() => import('./SafetyPlan')),
    label: 'Safety Plan',
    titleCancelButtonVariant: false,
    rootClassName: '',
  },
}

export default ModalsMap
